import { useState, useEffect } from 'react';
import { clauseService } from '../services/clauseService';
import type { Clause } from '@shared/types';

interface ClauseFilters {
  type?: string;
  approved?: boolean;
  search?: string;
}

export function useClauses(filters?: ClauseFilters) {
  const [clauses, setClauses] = useState<Clause[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadClauses = async () => {
    try {
      setLoading(true);
      const data = await clauseService.getClauses(filters);
      setClauses(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load clauses');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadClauses();
  }, [filters?.type, filters?.approved, filters?.search]);

  return {
    clauses,
    loading,
    error,
    reload: loadClauses,
  };
}

